var pageglobals = new PageGlobals();

var controller = {
    setHeight: function () {
        var categoryProductsContainerPixelHeight = getUrlHashParm('cph');
        if (categoryProductsContainerPixelHeight) {
            $('#' + categoryGlobals.productsDivId).css('height', categoryProductsContainerPixelHeight + 'px');
        }
    },
    unSetHeight: function () {
        $('#' + categoryGlobals.productsDivId).css('height', '');
    },
    initialize: function () {
        this.$window = $(window);
        if (this.categoryProductsContainerExists()) {
            var currentPageNumber = getUrlHashParm('cp');
            if (currentPageNumber == null) {
                currentPageNumber = 1;
            }
            controller.displayAllPagesUpThrough(currentPageNumber);
            controller.unSetHeight();
        }
    },
    categoryProductsContainerExists: function () {
        return categoryGlobals.productsDivId && ($('#' + categoryGlobals.productsDivId).length > 0);
    },
    displayAllPagesUpThrough: function (currentPageNumber) {
        controller.initPaging(currentPageNumber);
        var cometRequest = comet.newRequest(chandler, 'INIT', function (cometRequest) {
            growlMessages.showAll(cometRequest);
            var cpagesproducts = cometRequest.getWorkingObject();
            if (cpagesproducts) {
                cpagesproducts = cpagesproducts.jsonObject;
            }
            var cproductcount = cometRequest.getObject('PRODUCTCOUNT');
            if (cpagesproducts && cproductcount) {
                controller.productCount = cproductcount.value;
            }
            var cpagecount = cometRequest.getObject('PAGECOUNT');
            if (cpagesproducts && cpagecount) {
                controller.pageCount = cpagecount.value;
            }
            controller.updatePageCountHeader();
            pageglobals.set('cproductattributedefinition', cometRequest.getObject('PRODUCT_ATTRIBUTE_DEFINITION'));
            for (var pageNumber = 1; pageNumber <= currentPageNumber; pageNumber++) {
                var cpageproducts = controller.getProductsForPage(cpagesproducts, pageNumber);
                var isLastPage = pageNumber == currentPageNumber;
                controller.display(pageNumber, cpageproducts, isLastPage);
            }
            controller.onScroll();
        });
        cometRequest.addObjectId(categoryGlobals.categoryId);
        cometRequest.addParameter('PRODUCTSPERPAGE', categoryGlobals.productsPerPage);
        cometRequest.addParameter('SORTCOLUMNS', categoryGlobals.sortColumns);
        cometRequest.addParameter('STARTPAGENUMBER', 1);
        cometRequest.addParameter('ENDPAGENUMBER', currentPageNumber);
        cometRequest.addParameter('ICPARM', getUrlParm('_ic'));
        cometRequest.send();
    },
    jumpToPage: function (pageNumber) {
        $(window).scrollTop($('#' + this.pageDivIdPrefix + pageNumber).position().top);
    },
    getProductsForPage: function (cAllPageProductsArray, pageNumber) {
        var cAllPageProducts = cAllPageProductsArray.array;
        var cpageproducts = null;
        if (cAllPageProducts) {
            cpageproducts = [];
            var startingProductIndex = categoryGlobals.productsPerPage * (pageNumber - 1);
            var endingProductIndex = startingProductIndex + (categoryGlobals.productsPerPage - 1);
            if (endingProductIndex >= cAllPageProducts.length) {
                endingProductIndex = cAllPageProducts.length - 1;
            }
            for (var i = startingProductIndex; i <= endingProductIndex; i++) {
                var product = cAllPageProducts[i];
                cpageproducts[cpageproducts.length] = product;
            }
        }
        return cpageproducts;
    },
    pageProductCountDivId: 'categoryProductCount',
    pageHeaderDivIdPrefix: 'categoryProductsHeader',
    pageDivIdPrefix: 'categoryProductsPage',
    pagingFooterDivId: 'categoryProductsFooter',
    currentPageNumber: 0,
    initPaging: function (currentPageNumber) {
        controller.pageCount = 0;
        controller.productCount = 0;
        this.currentPageNumber = currentPageNumber;

        //
        var content = '';
        content += tags.div('', {
            id: this.pageProductCountDivId,
            cssClass: 'resultCount'
        });
        for (var pageNumber = 1; pageNumber <= currentPageNumber; pageNumber++) {
            content += this.getEmptyPageShellContent(pageNumber);
        }
        content += tags.div('', {
            id: this.pagingFooterDivId,
            cssClass: 'hideIt'
        });

        // write content to dom
        dynamic.setDivIdContent(categoryGlobals.productsDivId, content);

        // fire theme events (blocking)
        for (var pageNumber = 1; pageNumber <= currentPageNumber; pageNumber++) {
            categoryEvents.onPageLoading(this.pageHeaderDivIdPrefix + pageNumber, pageNumber);
        }
    },
    updatePageCountHeader: function () {
        dynamic.setDivIdContent(this.pageProductCountDivId, '' + controller.productCount + ' product' + (controller.productCount == 1 ? '' : 's'));
    },
    getEmptyPageShellContent: function (pageNumber) {
        var content = '';
        content += tags.div('', {
            id: this.pageHeaderDivIdPrefix + pageNumber,
            cssClass: 'resultsPageBreak'
        });
        {
            var loadingcontent = '';
            loadingcontent += tags.span(tags.img(SPINNERIMAGE) + ' Loading...', {
                cssClass: 'preloader'
            });
            content += tags.div(loadingcontent, {
                id: this.pageDivIdPrefix + pageNumber,
                cssClass: 'resultsPage'
            });
        }
        return content;
    },
    getPageHeaderContent: function (pageNumber) {
        var content = '';
        if (controller.pageCount > 0) {
            content += tags.span('Page ' + pageNumber + ' of ' + controller.pageCount);
        }
        return content;
    },
    display: function (pageNumber, cpageproducts, isLastPage) {
        var content = '';

        // header
        content += this.getPageHeaderContent(pageNumber);
        dynamic.setDivIdContent(this.pageHeaderDivIdPrefix + pageNumber, content);

        // body
        content = '';
        content += this.getPageContent(pageNumber, cpageproducts, isLastPage);

        // write content to dom
        dynamic.setDivIdContent(this.pageDivIdPrefix + pageNumber, content);

        // fire theme events (blocking)
        categoryEvents.onPageLoaded(this.pageDivIdPrefix + pageNumber, pageNumber);
    },
    getPageContent: function (pageNumber, cpageproducts, isLastPage) {
        var content = '';
        for (var i = 0, ni = cpageproducts ? cpageproducts.length : 0; i < ni; i++) {
            var cproduct = cpageproducts[i];
            var isLastProduct = isLastPage && (i + 1 == categoryGlobals.productsPerPage);
            content += this.getProductContent(cproduct, isLastProduct, pageNumber);
        }
        return content;
    },
    getProductContent: function (cproduct, isLastProduct, pageNumber) {
        var content = '';
        var divcontent1 = '';
        var productURL = this.getProductURL(cproduct, pageNumber);

        if (categoryGlobals.showThumbs) {
            var divcontent2 = '';
            var productThumbURL = cproduct.publishedThumbURL;
            if (hasValue(productThumbURL)) {
                divcontent2 += tags.a(tags.img(productThumbURL, cproduct.publishedThumbWidth, cproduct.publishedThumbHeight, {
                    alt: strWeb(cproduct.name)
                }), productURL, {
                    other: 'onmouseover="controller.setHash(' + pageNumber + ')"'
                });
            } else {
                divcontent2 += tags.a('', productURL, {
                    cssClass: 'noImage'
                });
            }
            divcontent1 += tags.div(divcontent2, {
                cssClass: 'productThumb'
            });
        }

        divcontent1 += tags.div(tags.a(strWeb(cproduct.name), productURL, {
            other: 'onmouseover="controller.setHash(' + pageNumber + ')"'
        }), {
            cssClass: 'productName'
        });

        if (cproduct.excerpt) {
            divcontent1 += tags.div(strUnweb(cproduct.excerpt), {
                cssClass: 'productExcerpt'
            });
        }

        // If include_product_attributes="true" was set, add them to the markup...
        if (categoryGlobals.includeProductAttributes) {
            divcontent1 += '<div class="customProductAttributes">'; // open .customProductAttributes containing div

            var cproductattributedefinition = pageglobals.cproductattributedefinition.jsonObject.fields;
            var cproductattributevalues = cproduct.productAttributesValue;
            var customAttributes = {};

            // Populate customAttributes object.
            // Only adds keys/values from the custom attribute values for this product (cproductattributevalues) that also have
            // keys that appear in in the product custom attribute definition (cproductattributedefinition).
            // This ensures that values for a custom attribute that were set on a product, but whose custom attribute has
            // been removed from custom product attribute definition will not appear - ensuring only currently "active"
            // custom product attributes are represented / displayed.
            if (cproductattributedefinition) {
                for (var prop in cproductattributevalues) {
                    if (cproductattributevalues.hasOwnProperty(prop)) {
                        for (var i = 0; i < cproductattributedefinition.length; i++) {
                            if (cproductattributedefinition[i].key === prop) {
                                customAttributes[prop] = cproductattributevalues[prop];
                            }
                        }
                    }
                }
            }

            // Now that the product's custom attribute values (cproductattributevalues) have been filtered against
            // the custom product attribute definitions (cproductattributedefinition) and populated to customAttributes,
            // iterate over customAttributes and create markup for each custom attribute
            for (var prop in customAttributes) {
                if (customAttributes.hasOwnProperty(prop)) {
                    divcontent1 += '<span class="customProductAttributes-attribute customProductAttributes-attribute_' + getCssClass(prop) + '">' + customAttributes[prop] + '</span>';
                }
            }

            divcontent1 += '</div>'; // close .customProductAttributes containing div
        }

        content += tags.div(divcontent1, {
            cssClass: 'aProductResult' + (isLastProduct ? ' lastProduct' : '')
        });

        return content;

        // helper function to turn a custom product attribute key into a valid css class name
        // replaces (multiple) spaces with a hyphen, lowercased
        // getCssClass("Some Custom Attribute Key") --> "some-custom-attribute-key"
        function getCssClass (input) {
            input = input || '';
            return input.replace(/\s\s*/g, '-').toLowerCase();
        }
    },
    getProductURL: function (cproduct, pageNumber) {
        return categoryGlobals.productBaseUrl + cproduct.urlPattern + '#c=' + categoryGlobals.categoryId + '&cp=' + pageNumber;
    },
    setHash: function (pageNumber) {
        setUrlHashParms('cp=' + pageNumber + '&cph=' + $('#' + categoryGlobals.productsDivId).height());
    },
    getNextPage: function () {
        var currentPageNumber = ++this.currentPageNumber;
        $('div.lastProduct').removeClass('lastProduct');

        var content = '';
        content += this.getEmptyPageShellContent(currentPageNumber);

        // write empty shell content to dom
        $(content).insertBefore('#' + this.pagingFooterDivId);

        // fire theme events (blocking)
        categoryEvents.onPageLoading(this.pageHeaderDivIdPrefix + currentPageNumber, currentPageNumber);

        var cometRequest = comet.newRequest(chandler, 'GETNEXTPAGEACTION', function (cometRequest) {
            growlMessages.showAll(cometRequest);
            var cpageproducts = cometRequest.getWorkingObject();
            if (cpageproducts && cpageproducts.jsonObject) {
                controller.display(currentPageNumber, cpageproducts.jsonObject.array, true);
                controller.onScroll();
            }
        });
        cometRequest.addParameter('PAGENUMBER', currentPageNumber);
        cometRequest.send();
    },
    onScroll: function () {
        // console.log('cat onScroll');
        if (controller.currentPageNumber < controller.pageCount) {
            var divPos = $('div.lastProduct').offset();
            if (divPos != null) {
                if (controller.$window.height() > (divPos.top - controller.$window.scrollTop())) {
                    controller.getNextPage();
                }
            }
        }
    }
};

var throttledOnScrollFunction = throttle(controller.onScroll, 200);

$(document).ready(function () {
    controller.setHeight();
});
$(window).load(function () {
    controller.initialize();
});
$(window).scroll(throttledOnScrollFunction);

// similar to the events object, but:
// - allows parameters to be passed to listener functions
// - blocks calls to the "event", so that all listeners finish before execution flow returns to caller
/*
//sample theme code - this would go into a theme file
if (!window.console) console = {log:function(){}};
var sampleThemeEventsContainerObjectWithFancyNameLikeCategoryEventsListener = {
  onPageLoading: function(divId, pageNumber) {
	  console.log('loading', {divId:divId, pageNumber:pageNumber});
  },
  onPageLoaded: function(divId, pageNumber) {
	  console.log('loaded', {divId:divId, pageNumber:pageNumber});
  }
};
$(function(){
  categoryEvents.registerOnPageLoadingListener(sampleThemeEventsContainerObjectWithFancyNameLikeCategoryEventsListener);
  categoryEvents.registerOnPageLoadedListener(sampleThemeEventsContainerObjectWithFancyNameLikeCategoryEventsListener);
});
*/
var categoryEvents = {
    // PageLoaded
    onPageLoadedListeners: new Array(),
    registerOnPageLoadedListener: function (listener) {
        if (listener != null && typeof listener == 'object' && typeof listener.onPageLoaded == 'function') {
            this.onPageLoadedListeners[this.onPageLoadedListeners.length] = listener;
        } else {
            throw new TypeError('expected an object having onPageLoaded function');
        }
    },

    // root function that calls registered listeners of PageLoaded event.
    // listeners should have provide a function with signature "onPageLoaded(divId, pageNumber)"
    onPageLoaded: function (divId, pageNumber) {
        for (var i = 0, ni = this.onPageLoadedListeners == null ? 0 : this.onPageLoadedListeners.length; i < ni; i++) {
            this.onPageLoadedListeners[i].onPageLoaded(divId, pageNumber);
        }
    },

    // PageLoaded
    onPageLoadingListeners: new Array(),
    registerOnPageLoadingListener: function (listener) {
        if (listener != null && typeof listener == 'object' && typeof listener.onPageLoading == 'function') {
            this.onPageLoadingListeners[this.onPageLoadingListeners.length] = listener;
        } else {
            throw new TypeError('expected an object having onPageLoading function');
        }
    },

    // root function that calls registered listeners of PageLoaded event.
    // listeners should have provide a function with signature "onPageLoading(divId, pageNumber)"
    onPageLoading: function (divId, pageNumber) {
        for (var i = 0, ni = this.onPageLoadingListeners == null ? 0 : this.onPageLoadingListeners.length; i < ni; i++) {
            this.onPageLoadingListeners[i].onPageLoading(divId, pageNumber);
        }
    }
};
